export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/9efedd6f8d84b8cf11b1862201b47d04.svg";